import { render } from "./ProjectTreeBtn.vue?vue&type=template&id=473713c3&scoped=true&lang=html"
import script from "./ProjectTreeBtn.vue?vue&type=script&lang=js"
export * from "./ProjectTreeBtn.vue?vue&type=script&lang=js"

import "./ProjectTreeBtn.vue?vue&type=style&index=0&id=473713c3&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473713c3"]])

export default __exports__